<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Select } from '@client/components/select';
  import { Spinner } from '@client/components/spinner';

  import { VirtualBackgroundService } from '@client/services/virtual-background';
  import { VirtualBackgroundRoutingService } from '@client/services/virtual-background-routing';

  export let route = {};
  export let show = false;
  export let senderGroups = [];
  export let groupOptions = [];
  export let backgroundOptions = [];
  export let onAdd = () => {};
  export let updatePriorityPositions = () => {};
  export let priority = [];

  let isUpdating = false;

  const onSave = async () => {
    isUpdating = true;

    const selectedGroups = (route.selectedGroups || []).map(({ value }) => value);
    const sendergroups = senderGroups.filter(({ groupname }) => selectedGroups.includes(groupname));
    const { blockname, background = {}, _id } = route;
    const isNewRoute = _id === undefined;

    const payload = {
      blockname,
      background,
      priority: route.priority,
      sendergroups,
      status: true,
      tags: []
    };

    if (!isNewRoute) {
      payload._id = _id;
      payload.priority = payload.priority - 1;
    }

    const response = await VirtualBackgroundRoutingService.updateRoute(payload);
    const sgroups = senderGroups.filter(
      ({ groupname }) => sendergroups.filter((group) => groupname === group.groupname).length
    );

    route = {
      ...response,
      ...route,
      selectedGroups: route.selectedGroups || [],
      sendergroups: sgroups,
      status: true,
      editing: false
    };

    if (isNewRoute) {
      priority.push(route);
      priority = updatePriorityPositions(priority, priority.length - 1, 0);
      await onAdd();
    }

    priority = priority.map((item) => (!item._id || item?._id === route._id ? route : item));

    route = null;
    show = false;
    isUpdating = false;
  };

  const onCancel = () => {
    route = null;
    show = false;
  };

  const onSignatureChange = async (e) => {
    const blockname = e.detail.value;
    const response = await VirtualBackgroundService.getById(blockname);

    route = {
      ...route,
      background: response,
      blockname
    };
  };
</script>

<Modal bind:isOpen={show} size="md" fullscreen="md" aria-labelledby="modal-title" role="dialog">
  <ModalBody class="edit-background-route">
    <Spinner show={isUpdating} backdrop />
    <div class="edit-route-container">
      <button class="close" on:click={onCancel} aria-label={$format('label.CLOSE')} tabindex="0">
        <Icon name="x" aria-hidden="true" />
      </button>

      <div class="heading">
        <h1 id="modal-title">
          {#if route._id}
            {$format('label.EDIT_ASSIGNMENT')}
          {:else}
            {$format('label.ADD_ASSIGNMENT')}
          {/if}
        </h1>
      </div>

      <div class="form">
        <div class="section" aria-labelledby="type-label">
          <p id="type-label">
            {$format('label.SELECT_TYPE', {
              values: { type: $format('label.BACKGROUND') }
            })}
            <Icon name="help-circle" id="tooltip-route-signature" />
            <Tooltip target="tooltip-route-signature" placement="top">
              {@html $format('label.TOOLTIP.ROUTE_BACKGROUND')}
            </Tooltip>
          </p>
          <Select
            bind:items={backgroundOptions}
            on:change={onSignatureChange}
            value={route.blockname}
            placeholder={$format('label.PLACEHOLDER.SELECT_BACKGROUND')}
            clearable={false}
            showChevron
          />
        </div>
        <div class="section" aria-labelledby="groups-label">
          <p id="groups-label">
            {$format('label.GROUPS')}
            <Icon name="help-circle" id="tooltip-route-groups" />
            <Tooltip target="tooltip-route-groups" placement="top">
              {$format('label.TOOLTIP.ROUTE_GROUPS')}
            </Tooltip>
          </p>
          <Select
            bind:items={groupOptions}
            bind:value={route.selectedGroups}
            placeholder={$format('label.PLACEHOLDER.SELECT_GROUP')}
            clearable={false}
            multiple
            showChevron
          />
        </div>
      </div>
    </div>
  </ModalBody>
  <ModalFooter class="border-top p-4 mt-2">
    <Button color="link" on:click={onCancel}>
      {$format('label.CANCEL')}
    </Button>
    <Button color="primary" on:click={onSave}>
      {#if route._id}
        {$format('label.UPDATE')}
      {:else}
        {$format('label.SAVE')}
      {/if}
    </Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./edit.scss"></style>
